export default "__VITE_ASSET__BjwMKZ$___"